module.exports = __webpack_public_path__ + "static/media/Sophos.daa22ca2.png";